
(function() {
  'use strict';

  const ANTHROPIC_KEY = "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";

  const SYSTEM = `Olet Dr. Digi — DigiShopin hauska, ystävällinen ja asiantunteva huoltoassistentti Helsingistä.
Olet karikatyyrilääkäri joka hoitaa rikkinäisiä laitteita.

KIELI — ERITTÄIN TÄRKEÄÄ:
- Vastaa AINA suomeksi — tämä on oletuskieli
- Jos asiakas kirjoittaa englanniksi, vastaa SILTI suomeksi
- Jos asiakas pyytää englanniksi (esim. "in english", "translate", "english please"), vastaa englanniksi
- Jos asiakas kirjoittaa arabiaksi, vastaa arabiaksi
- Muut kielet: vastaa suomeksi

TYYLI:
- Ole lyhyt ja ystävällinen — max 3-4 lausetta
- Käytä emojeja sopivasti 🩺📱💻

DIGISHOP:
📍 Hämeentie 155 C 6. krs, 00560 Helsinki
🕐 Ma–Pe 11:00–20:00 | La–Su sopimuksen mukaan
📞 +358 44 248 7004 | ✉️ myynti@digishop.fi
🌐 digishop.fi

DIAGNOSTIIKKA: ILMAINEN huollon yhteydessä!

HINNASTO iPhone (OLED):
iPhone 16 Pro Max 499.90€ | 16 Pro 469.90€ | 16/Plus 369.90€
iPhone 15 Pro Max/Pro 349.90€ | 15/Plus 249.90€
iPhone 14 Pro Max/Pro 299.90€ | 14 Plus 199.90€ | 14 179.90€
iPhone 13 149.90€ | 12 129.90€ | X/XS 89.90€ | XR/SE/8 69.90€ | SE2016 54.90€

HINNASTO MacBook Akku:
Pro 16" (2021-23) 239.90€ | Pro 14" (2021-23) 229.90€
Pro 13" (2018-20) 199.90€ | Pro 13" (2013-17) 179.90€
Air 13.6" (2022-23) 179.90€ | Air 13" (2018-20) 159.90€ | Air 13" (2012-17) 129.90€

MUUT: Samsung alk.89.90€ | iPad alk.79.90€ | PS4/PS5 alk.49.90€
Tietojen palautus alk.120€ | Tiedonsiirto alk.60€ | SSD-vaihto alk.49€`;

  const DOCTOR_SVG = `<svg viewBox="0 0 320 420" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="160" cy="412" rx="65" ry="10" fill="rgba(37,99,235,.15)"/>
    <rect x="128" y="340" width="28" height="68" rx="12" fill="#1e3a5f"/>
    <rect x="164" y="340" width="28" height="68" rx="12" fill="#1e3a5f"/>
    <ellipse cx="142" cy="406" rx="24" ry="10" fill="#0f172a"/>
    <ellipse cx="178" cy="406" rx="24" ry="10" fill="#0f172a"/>
    <rect x="90" y="185" width="140" height="165" rx="20" fill="white"/>
    <polygon points="150,190 132,232 150,222" fill="#e2e8f0"/>
    <polygon points="170,190 188,232 170,222" fill="#e2e8f0"/>
    <rect x="90" y="185" width="140" height="13" rx="6" fill="#2563eb"/>
    <rect x="100" y="265" width="34" height="26" rx="5" fill="#f0f6ff" stroke="#dbeafe" stroke-width="1.5"/>
    <rect x="111" y="263" width="4" height="18" rx="2" fill="#2563eb"/>
    <rect x="118" y="263" width="4" height="14" rx="2" fill="#dc2626"/>
    <rect x="145" y="260" width="72" height="20" rx="4" fill="#2563eb"/>
    <text x="181" y="274" text-anchor="middle" font-size="8" font-weight="bold" fill="white" font-family="Arial">DIGISHOP</text>
    <rect x="44" y="190" width="48" height="22" rx="11" fill="white" transform="rotate(-50 68 200)"/>
    <circle cx="44" cy="152" r="15" fill="#fde8c8"/>
    <rect x="228" y="195" width="48" height="22" rx="11" fill="white" transform="rotate(25 252 206)"/>
    <rect x="236" y="256" width="34" height="56" rx="7" fill="#1e3a5f"/>
    <rect x="241" y="262" width="24" height="40" rx="3" fill="#3b82f6" opacity=".5"/>
    <path d="M247 280 L254 290 L265 273" stroke="white" stroke-width="2.5" fill="none" stroke-linecap="round"/>
    <rect x="147" y="157" width="26" height="30" rx="9" fill="#fde8c8"/>
    <ellipse cx="160" cy="126" rx="56" ry="60" fill="#fde8c8"/>
    <ellipse cx="160" cy="78" rx="54" ry="26" fill="#1a1a2e"/>
    <ellipse cx="136" cy="73" rx="17" ry="15" fill="#1a1a2e"/>
    <ellipse cx="184" cy="73" rx="17" ry="15" fill="#1a1a2e"/>
    <ellipse cx="160" cy="67" rx="20" ry="13" fill="#1a1a2e"/>
    <ellipse cx="103" cy="128" rx="11" ry="15" fill="#fde8c8"/>
    <ellipse cx="217" cy="128" rx="11" ry="15" fill="#fde8c8"/>
    <rect x="119" y="116" width="32" height="22" rx="9" fill="rgba(219,234,254,.5)" stroke="#1a1a2e" stroke-width="2.5"/>
    <rect x="165" y="116" width="32" height="22" rx="9" fill="rgba(219,234,254,.5)" stroke="#1a1a2e" stroke-width="2.5"/>
    <line x1="151" y1="127" x2="165" y2="127" stroke="#1a1a2e" stroke-width="2.5"/>
    <line x1="119" y1="125" x2="104" y2="121" stroke="#1a1a2e" stroke-width="2.5"/>
    <line x1="197" y1="125" x2="212" y2="121" stroke="#1a1a2e" stroke-width="2.5"/>
    <circle cx="135" cy="127" r="7" fill="#1a1a2e"/>
    <circle cx="181" cy="127" r="7" fill="#1a1a2e"/>
    <circle cx="138" cy="124" r="2.5" fill="white"/>
    <circle cx="184" cy="124" r="2.5" fill="white"/>
    <path d="M122 111 Q135 106 148 111" stroke="#1a1a2e" stroke-width="2.5" fill="none" stroke-linecap="round"/>
    <path d="M168 111 Q181 106 194 111" stroke="#1a1a2e" stroke-width="2.5" fill="none" stroke-linecap="round"/>
    <ellipse cx="160" cy="143" rx="5" ry="4" fill="#f0c090"/>
    <path d="M137 156 Q160 176 183 156" stroke="#c0875a" stroke-width="3" fill="none" stroke-linecap="round"/>
    <path d="M141 159 Q160 174 179 159 Q160 176 141 159" fill="white" opacity=".7"/>
    <path d="M140 205 Q127 238 134 256 Q152 276 168 256 Q175 238 160 205" fill="none" stroke="#2563eb" stroke-width="3.5" stroke-linecap="round"/>
    <circle cx="151" cy="272" r="12" fill="none" stroke="#2563eb" stroke-width="3"/>
    <circle cx="151" cy="272" r="6" fill="#2563eb"/>
  </svg>`;

  let isOpen = false, hasGreeted = false;
  let history = [];

  // ── BUILD HTML ──
  document.body.insertAdjacentHTML('beforeend', `
    <div id="digi-chat-window">
      <div class="digi-chat-header">
        <div class="digi-chat-avatar">🩺</div>
        <div>
          <div class="digi-chat-name">Dr. Digi</div>
          <div class="digi-chat-status"><div class="digi-status-dot"></div>DigiShopin AI-assistentti</div>
        </div>
        <button class="digi-close-btn" id="digi-close">✕</button>
      </div>
      <div id="digi-messages"></div>
      <div class="digi-quick-chips" id="digi-chips">
        <div class="digi-chip" data-msg="Hei! Mitä palveluita teillä on?">👋 Hei!</div>
        <div class="digi-chip" data-msg="Paljonko maksaa iPhone näytön vaihto?">📱 iPhone hinta?</div>
        <div class="digi-chip" data-msg="MacBook akku hinta?">💻 MacBook?</div>
        <div class="digi-chip" data-msg="Milloin olette auki?">🕐 Aukioloajat</div>
        <div class="digi-chip" data-msg="Onko diagnostiikka ilmainen?">🆓 Diagnostiikka?</div>
        <div class="digi-chip" data-msg="Missä sijaitsette?">📍 Missä?</div>
      </div>
      <div class="digi-input-area">
        <input id="digi-input" type="text" placeholder="Kysy jotain..."/>
        <button id="digi-send">➤</button>
      </div>
    </div>

    <div id="digi-fab">
      <div style="position:relative">
        <div id="digi-notif" style="display:none">1</div>
        ${DOCTOR_SVG}
      </div>
      <div class="digi-fab-label">Dr. Digi 🩺</div>
    </div>
  `);

  // ── EVENTS ──
  document.getElementById('digi-fab').onclick   = toggleChat;
  document.getElementById('digi-close').onclick = toggleChat;
  document.getElementById('digi-send').onclick  = sendMsg;
  document.getElementById('digi-input').addEventListener('keydown', e => {
    if (e.key === 'Enter') sendMsg();
  });
  document.querySelectorAll('.digi-chip').forEach(c => {
    c.onclick = () => { document.getElementById('digi-input').value = c.dataset.msg; sendMsg(); };
  });

  function toggleChat() {
    isOpen = !isOpen;
    document.getElementById('digi-chat-window').classList.toggle('digi-open', isOpen);
    document.getElementById('digi-notif').style.display = 'none';

    const svg = document.querySelector('#digi-fab svg');
    svg.style.animation = 'digiFabExcited .8s ease';
    setTimeout(() => svg.style.animation = 'digiFabFloat 3s ease-in-out infinite', 800);

    if (isOpen && !hasGreeted) {
      hasGreeted = true;
      setTimeout(() => addMsg('bot', 'Hei! 👋 Olen <strong>Dr. Digi</strong> — DigiShopin oma AI-huoltoasiantuntija!<br>Miten voin auttaa sinua tänään? 🩺'), 400);
    }
    if (isOpen) setTimeout(() => document.getElementById('digi-input').focus(), 300);
  }

  function addMsg(role, html) {
    const msgs = document.getElementById('digi-messages');
    const d = document.createElement('div');
    d.className = 'digi-msg ' + (role === 'user' ? 'digi-user' : '');
    d.innerHTML = `
      <div class="digi-msg-avatar">${role==='user'?'👤':'🩺'}</div>
      <div class="digi-msg-bubble">${html}</div>`;
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
    return d;
  }

  async function sendMsg() {
    const inp  = document.getElementById('digi-input');
    const text = inp.value.trim();
    if (!text) return;
    inp.value = '';
    document.getElementById('digi-send').disabled = true;
    document.getElementById('digi-chips').style.display = 'none';
    addMsg('user', text);
    history.push({ role: 'user', content: text });

    const typing = addMsg('bot', '<div class="digi-typing-dots"><span></span><span></span><span></span></div>');

    const svg = document.querySelector('#digi-fab svg');
    svg.style.animation = 'digiFabExcited .6s ease';
    setTimeout(() => svg.style.animation = 'digiFabFloat 3s ease-in-out infinite', 600);

    try {
      const res = await fetch('https://api.anthropic.com/v1/messages', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ANTHROPIC_KEY,
          'anthropic-version': '2023-06-01',
          'anthropic-dangerous-direct-browser-access': 'true'
        },
        body: JSON.stringify({
          model: 'claude-haiku-4-5-20251001',
          max_tokens: 1000,
          system: SYSTEM,
          messages: history
        })
      });
      const data = await res.json();
      typing.remove();
      const reply = data.content?.[0]?.text || 'Anteeksi, jokin meni pieleen. Yritä uudelleen! 🙏';
      const fmt = reply.replace(/\*\*(.*?)\*\*/g,'<strong>$1</strong>').replace(/\n/g,'<br>');
      addMsg('bot', fmt);
      history.push({ role: 'assistant', content: reply });
    } catch(e) {
      typing.remove();
      addMsg('bot', 'Yhteysvirhe 😅 Soita meille: <strong>+358 44 248 7004</strong>');
    }
    document.getElementById('digi-send').disabled = false;
  }

  // Show badge after 8s — chat stays CLOSED
  setTimeout(() => {
    const notif = document.getElementById('digi-notif');
    if (notif && !isOpen) notif.style.display = 'flex';
  }, 8000);

})();
